import { useQuery } from '@tanstack/react-query';
import { api, toApiError, type ApiErrorShape } from '@/api/client';
import { queryKeys } from '@/api/queryClient';
import type { components } from '@/api/schema';

type PublicConfigResponse = components['schemas']['PublicConfigResponse'];

function assertData<T>(data: T | undefined, err: unknown, status: number): asserts data is T {
  if (err !== undefined || data === undefined) {
    throw toApiError(err, status);
  }
}

export function usePublicConfig() {
  return useQuery<PublicConfigResponse, ApiErrorShape>({
    queryKey: queryKeys.publicConfig,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error, response } = await api.GET('/api/v1/config');
      assertData(data, error, response.status);
      return data;
    },
  });
}
